import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "menu-bar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "layout-logo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" })
], -1)
const _hoisted_3 = { class: "menu-ul" }
const _hoisted_4 = ["onClick"]


import { Nav } from "@/types/nav";
import { useMenu } from "@/composables/useMenu";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const router = useRouter();

const { showMenu, closeMenu, openMenu } = useMenu();
const menu: Array<Nav> = [
  {
    value: "搜索",
    link: "./#/search",
    outside: true,
    icon: "",
    type: "normal",
    list: [],
  },
  {
    value: "职业",
    icon: "",
    link: "./#/races",
    outside: false,
    type: "logo",
    list: [],
  },
  {
    value: "游戏图鉴",
    link: "./#/catalog/set2",
    outside: false,
    type: "normal",
    icon: "",
    list: [],
  },
  {
    value: "现金道具",
    link: "./#/catalog/set5",
    outside: true,
    icon: "",
    type: "normal",
    list: [],
  },
  {
    value: "新手引导",
    icon: "",
    link: "./#/catalog/set0",
    outside: false,
    type: "logo",
    list: [],
  },
  {
    value: "boss介绍",
    link: "./#/catalog/set3",
    outside: false,
    type: "normal",
    icon: "",
    list: [],
  },
  {
    value: "次元站公告",
    link: "./#/catalog/set6",
    outside: false,
    icon: "",
    type: "normal",
    list: [],
  },
  {
    value: "系统介绍",
    icon: "",
    link: "./#/catalog/set1",
    outside: false,
    type: "logo",
    list: [],
  },
  {
    value: "版本介绍",
    link: "./#/catalog/set4",
    outside: false,
    type: "normal",
    icon: "",
    list: [],
  },
  {
    value: "玩家投稿",
    link: "./#/catalog/set7",
    outside: false,
    type: "normal",
    icon: "",
    list: [],
  },
];

function navigate(item: Nav) {
  console.log();

  window.location.href = item.link;
}

const exposedMethods = {
  openMenu,
  closeMenu,
};

expose(exposedMethods);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "cover-menu",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(closeMenu) && _unref(closeMenu)(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item, index) => {
          return _createElementVNode("li", {
            key: index,
            class: "item"
          }, [
            _createElementVNode("div", {
              class: "nav-link",
              onClick: ($event: any) => (navigate(item))
            }, _toDisplayString(item.value), 9, _hoisted_4)
          ])
        }), 64))
      ])
    ])
  ], 512)), [
    [_vShow, _unref(showMenu)]
  ])
}
}

})